import { Map, Record, Set } from 'immutable';

import { DcCoreElementType } from '../dc-core-types';
import { CurrentUser } from '../domain/current-user';
import { MarketplaceMemberEntity } from '../domain/marketplace-member.entity';
import { ElementPermission } from '../domain/permission-types';

export const CoreSliceKey = 'main';
export interface ICoreOriginalSliceState {
	currentUser: CurrentUser | null;
	availablePermissions: Map<DcCoreElementType, Set<ElementPermission>>;
	availableMarketPlaceMembers: {
		members: Map<string, MarketplaceMemberEntity>;
		total: number;
	};
}

const stateDefaults: ICoreOriginalSliceState = {
	currentUser: null,
	availablePermissions: Map(),
	availableMarketPlaceMembers: {
		members: Map(),
		total: 0,
	},
};

export class CoreOriginalSliceState extends Record<ICoreOriginalSliceState>(
	stateDefaults
) {
	public static readonly key = CoreSliceKey;

	public setCurrentUser(user: CurrentUser): CoreOriginalSliceState {
		return this.set('currentUser', user);
	}

	public setAvailablePermissions(
		val: Map<DcCoreElementType, Set<ElementPermission>>
	): CoreOriginalSliceState {
		return this.set('availablePermissions', val);
	}

	public setAvailableMarketplaceMembers(
		members: Map<string, MarketplaceMemberEntity>,
		total: number
	): CoreOriginalSliceState {
		return this.set('availableMarketPlaceMembers', {
			members,
			total,
		});
	}

	public resetAvailableMarketplaceMembers(): CoreOriginalSliceState {
		return this.set(
			'availableMarketPlaceMembers',
			stateDefaults.availableMarketPlaceMembers
		);
	}
}
